import TextField from "../../../../components/fields/textField/TextField.vue";
import SelectField from "../../../../components/fields/selectField/SelectField.vue";
import PeriodoField from "../../../../components/fields/periodoField/PeriodoField.vue";
import TextAreaField from "../../../../components/fields/textAreaField/TextAreaField.vue";
import FileInputField from "../../../../components/fields/file-input-field/FileInputField.vue";
import { SnackBarModule } from "../../../../modules/SnackBarModule";
import moment from "moment";
import { AJUSTAR_FERIAS_TIPO_ALTERACAO } from "../../../../constants";
import { AgendarFeriasCivilService } from "../../../../services/AgendarFeriasCivilService.js";
import { FeriasService } from "../../../../services/FeriasService";
import { FeriasCivilService } from "../../../../services/FeriasCivilService"; // Novo import
import { SolicitarFeriasService } from "../../../../services/SolicitarFeriasService";
import ProrrogarInterromperFerias from "./prorrogar-interromper-ferias/ProrrogarInterromperFerias.vue";

export default {
  name: "AgendarFerias",

  props: {
    options: {
      type: Array,
      required: true,
    }
  },

  components: {
    TextField,
    SelectField,
    PeriodoField,
    TextAreaField,
    FileInputField,
    ProrrogarInterromperFerias
  },

  beforeMount() {
    this.initializeForm();
  },

  mounted() {
    this.id = this.selected;
    this.options.tipoAlteracao = AJUSTAR_FERIAS_TIPO_ALTERACAO;
    this.validaExibicaoReprogramarFerias();

  },

  data: () => ({
    id: null,
    actionsDialogt: false,
    interromperDialog: false,
    unidadeLotacao:null,
    exercicio:null,
    civil: null,
    tipoCivil: null,
    parcela: null,
    form: {},
    disabledReprogramacao: false,
    formInterromper:{},
    feriasCassadasPorExercicio: {}, // Novo campo para armazenar o status de férias cassadas
    loading: {
      field: false,
      btn: false,
    }
  }),


  disabled: false,

  watch: {
    unidadeLotacao: async function(unidade_id){
      await this.pegarPessoasPorUnidadeSemFeriasCivil(unidade_id);
      this.$forceUpdate()
    },
    civil: async function(pessoa_id){
      this.pegarGraduacaoPorPessoa(pessoa_id);
      this.pegarTipoCivilPorPessoa(pessoa_id);
      await this.pegarExercicioPorPessoa(pessoa_id);
      this.$forceUpdate()
    },
    exercicio: async function(exercicio){
      this.pegarDiasPendentesDaPessoa(exercicio,this.civil);
      this.pegarParcelasDaPessoa(exercicio, this.civil);
      
      // Verificar se há férias cassadas para este exercício
      if (exercicio) {
        await this.verificarFeriasCassadas(exercicio);
      }
      
      this.$forceUpdate()
    }
  },

  methods: {
    async calculateDays() {
      if (this.form.dataInicio != null) {
        // PRIMEIRO: Verificar se há férias cassadas para o exercício
        if (this.exercicio && !(this.exercicio in this.feriasCassadasPorExercicio)) {
          await this.verificarFeriasCassadas(this.exercicio);
        }

        const diasSolicitados = parseInt(this.form.numeroDiasSolicitados) || 0;

        // Verificar se há férias cassadas para este exercício
        const temFeriasCassadas = this.exercicio && this.feriasCassadasPorExercicio[this.exercicio];

        // Só aplica a validação de dias específicos se NÃO há férias cassadas
        if (!temFeriasCassadas && ![10, 15, 25].includes(diasSolicitados)) {
          SnackBarModule("O número de dias deve ser 10, 15 ou 25.", "error");
          return;
        }

        // Validar se o total solicitado não deixará saldo impossível
        const saldoAposOperacao = this.form.numeroDias - diasSolicitados;
        if (saldoAposOperacao > 0 && saldoAposOperacao < 10) {
          SnackBarModule(`Não é possível solicitar ${diasSolicitados} dias pois sobraria um saldo de ${saldoAposOperacao} dias que não poderia ser utilizado. Com saldo de ${this.form.numeroDias} dias, você deve solicitar ${this.form.numeroDias} dias.`, "error");
          return;
        }

        // Se o saldo é menor que 25, só pode solicitar o saldo exato
        if (this.form.numeroDias < 25 && diasSolicitados !== this.form.numeroDias) {
          SnackBarModule(`Com saldo de ${this.form.numeroDias} dias, você deve solicitar exatamente ${this.form.numeroDias} dias.`, "error");
          return;
        }

        const formData = new FormData();
        formData.append("data_ini", moment(this.form.dataInicio).format("YYYY-MM-DD"));
        formData.append("dias", this.form.numeroDiasSolicitados);
        const response = await SolicitarFeriasService.calcularDiasUteis(formData);
        this.form.dataFim = response.dataFim;
        this.form.numeroDiasSolicitados = response.dias_uteis;
        return;
      }
      return SnackBarModule("Preencha o campo de data inicial", "error");
    },

    initializeForm() {
      this.options.postoGraduacao = [],
      this.options.civils = [],

      this.form = {
        dataInicio: null,
        dataFim: null,
        numeroDias: null,
        numeroDiasSolicitados: null,

        idTipo: 5,

      }

    },

    async pegarPessoasPorUnidadeSemFeriasCivil(unidade_id){
      const response = await AgendarFeriasCivilService.pegarPessoasPorUnidadeSemFerias(unidade_id);
      this.options.civils =  response.map(el => {
        return {
          text: el.nome,
          value: el.id,
        }
      });


      this.options.civils?.unshift({ text: "Selecione", value: "" })

      return this.options.civils;
    },
    async pegarGraduacaoPorPessoa(pessoa_id){
      const response = await AgendarFeriasCivilService.pegarGraduacaoPorPessoa(pessoa_id);
      this.options.postoGraduacao = response[0].graduacao
      return;
    },
    async pegarDiasPendentesDaPessoa(exercicio,pessoa_id){
      const response = await AgendarFeriasCivilService.pegarDiasPendentesDaPessoa(exercicio,pessoa_id);
      this.form.numeroDias = response

      return;
    },

    async pegarParcelasDaPessoa(exercicio,pessoa_id){
      const response = await AgendarFeriasCivilService.pegarParcelasDaPessoa(exercicio,pessoa_id);
      this.formInterromper.dataInicio = response.data_ini;
      this.formInterromper.dataFim = response.data_fin;

      return;
    },

    async pegarExercicioPorPessoa(pessoa_id){
      const response = await FeriasService.getExercicioPorMilitar(pessoa_id);
      this.options.exercicio = response.map(el => {
        return {
          text: el.ano,
          value: el.ano,
        }
      });
      this.options.exercicio?.unshift({ text: "Selecione", value: "" })

    },

    async pegarTipoCivilPorPessoa(pessoa_id){
      const tipoCivil = await AgendarFeriasCivilService.getTipoCivil(pessoa_id);
      this.tipoCivil = tipoCivil
    },

    prepareFormAgendar() {
      if (!this.$refs.form.validate()) {
        SnackBarModule("Campo(s) inválidos", "error");
        return;
      }

      const diasSolicitados = parseInt(this.form.numeroDiasSolicitados) || 0;

      // Verificar se há férias cassadas para este exercício
      const temFeriasCassadas = this.exercicio && this.feriasCassadasPorExercicio[this.exercicio];

      // Só aplica a validação de dias específicos se NÃO há férias cassadas
      if (!temFeriasCassadas && ![10, 15, 25].includes(diasSolicitados)) {
        SnackBarModule("O número de dias deve ser 10, 15 ou 25.", "error");
        return;
      }

      const saldoAposOperacao = this.form.numeroDias - diasSolicitados;
      if (saldoAposOperacao > 0 && saldoAposOperacao < 10) {
        SnackBarModule(`Não é possível solicitar ${diasSolicitados} dias pois sobraria um saldo de ${saldoAposOperacao} dias que não poderia ser utilizado.`, "error");
        return;
      }

      if (this.form.numeroDias < 25 && diasSolicitados !== this.form.numeroDias) {
        SnackBarModule(`Com saldo de ${this.form.numeroDias} dias, você deve solicitar exatamente ${this.form.numeroDias} dias.`, "error");
        return;
      }

      const formData = new FormData();
      formData.append("data_ini", moment(this.form.dataInicio).format("YYYY-MM-DD"));
      formData.append("data_fin", moment(this.form.dataFim).format("YYYY-MM-DD"));
      formData.append("dias", this.form.numeroDiasSolicitados);
      formData.append("id_sigrh", this.civil);
      formData.append("id_tipo", this.form.idTipo);
      formData.append("exercicio", this.exercicio);

      this.saveFormAgendar(formData);
      return;
    },

    async validaExibicaoReprogramarFerias() {
      const response = await AgendarFeriasCivilService.validaExibicaoReprogramarFerias();
      if (response.reprogramacao) {
        this.disabledReprogramacao = true;
      } else {
        this.disabledReprogramacao = false;
      }
    },


    async saveFormAgendar(formData) {
      this.loading.btn = true;
      const response = await AgendarFeriasCivilService.agendarFerias(formData);
      this.loading.btn = false;
      if (response) {
        this.close();
      }
    },

    close() {
      this.$refs.form.reset();
      this.$emit("on-close");
    },

    closeActionsDialog() {
      this.initializeForm();
      this.options.civils = [];
      this.options.postoGraduacao = [];
      this.form.formInterromper = "";
      this.actionsDialog = false;
      this.getFerias();
    },

    // Método para verificar se deve aplicar a validação de dias
    deveAplicarValidacaoDias(exercicio) {
      return !this.feriasCassadasPorExercicio[exercicio];
    },

    getRulesForDias() {
      const exercicio = this.exercicio;
      const baseRules = [
        (v) => !!v || 'Campo obrigatório não informado.',
        (v) => !!(v > 0) || 'O número de dias deve ser maior que zero',
        (v) => !!(v <= this.form.numeroDias) || 'O número de dias está acima do saldo',
      ];

      // Se houver férias cassadas, não aplica a regra dos dias específicos
      if (exercicio && this.feriasCassadasPorExercicio[exercicio]) {
        return baseRules;
      }

      // Só aplica a validação de dias específicos se NÃO há férias cassadas
      if (exercicio) {
        baseRules.push(
          (v) => !!(v == 10 || v == 15 || v == 25) || 'O número de dias úteis solicitados deverá ser 10, 15 ou 25 dias.'
        );
      }

      return baseRules;
    },

    async verificarFeriasCassadas(exercicio) {
      const postData = new FormData();
      postData.append("exercicio", exercicio);
      postData.append("solicitante", this.civil);
      try {
        const response = await FeriasCivilService.verificarFeriasCassadas(postData);
        if (response && response.tem_ferias_cassadas_ou_convocadas !== undefined) {
          this.$set(this.feriasCassadasPorExercicio, exercicio, response.tem_ferias_cassadas_ou_convocadas);
        } 
      } catch (error) {
        console.error('Erro ao verificar férias cassadas:', error);
        // Em caso de erro, assume que não há férias cassadas (comportamento padrão)
        this.$set(this.feriasCassadasPorExercicio, exercicio, false);
      }
    },
  },
};